import '../Assets/Styles/register.css';
import React, { useEffect, useState } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';

import Box from '@mui/material/Box';

// Load Actions
import * as AppActions from '../Store/Actions/App';

const AlertView = (props) => {
  const {
    alert,
    setAlert,
    alertTitle,
    alertBody,
    alertAction,
    setAlertAction,
    scrollBlock,
    setDialog
  } = props;

  // Controle local da visibilidade do Dialog
  const [visible, setVisible] = useState(alert);

  // Sincroniza estado local com o estado global de alerta
  useEffect(() => {
    setVisible(alert);
  }, [alert]);

  const close = () => {
    console.log('[AlertModal] Executando close()');
    setVisible(false);     // controla localmente
    setAlert(false);       // notifica componente pai

    // Executa a ação pós-alerta, se houver
    if (typeof alertAction === "function") {
      alertAction();
      setAlertAction?.(null); // limpa após uso
    } else if (alertAction === "closeRegisterModal") {
      setDialog?.('registerModal', false);
    } else if (alertAction === "closeAgencyModal") {
      setDialog?.('agencyModal', false);
    }

    // Restaura o scroll se necessário
   /* if (scrollBlock) {
      setTimeout(() => {
        document.body.classList.add('p-overflow-hidden');
      }, 300);
    }*/

  };

  const footerContent = (
    <div className="modalFooterButtonsEnd">
      <Button label="OK" icon="pi pi-times" className="textButton" onClick={close} />
    </div>
  );

  return (
    <Dialog
      header={alertTitle}
      visible={visible}
      onHide={close}
      style={{ width: '30vw' }}
      breakpoints={{ '1400px': '40vw','960px': '50vw', '641px': '96vw' }}
      footer={footerContent}
      dismissableMask
    >
      <Box className="terms">
        <div>{alertBody}</div>
      </Box>
    </Dialog>
  );
};
 
const mapStateToProps = store => ({
  dialog: store.appReducer.dialog
});

const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AlertView);
